export const normalizeWalletLabel = (value: string): string => value.trim().toLowerCase();

/** Single wallet with the same name as its group — skip nested accordion header. */
export const shouldFlattenWalletInGroup = (
  groupName: string,
  walletName: string,
  walletsInGroup: number,
): boolean =>
  walletsInGroup === 1 &&
  normalizeWalletLabel(groupName) === normalizeWalletLabel(walletName);
